import { isAbsoluteUrl as s } from "./chunk331.js";
const a = (o, t, n = !1) => {
  const { protocol: r, host: i } = window.location, e = new URL(s(o) ? o : `${r}//${i}${o}`);
  t && Object.entries(t).forEach(([l, c]) => {
    e.searchParams.append(l, c);
  }), n ? window.location.replace(e.toString()) : window.location.href = e.toString();
}, w = ({ path: o, queryParams: t, replaceState: n = !1 }) => (a(o, t, n), null);
export {
  w as NavigateToUrl,
  a as navigateToUrl
};
